import { render, staticRenderFns } from "./pdetail.vue?vue&type=template&id=0c278f79&scoped=true&"
import script from "./pdetail.vue?vue&type=script&lang=js&"
export * from "./pdetail.vue?vue&type=script&lang=js&"
import style0 from "./pdetail.vue?vue&type=style&index=0&id=0c278f79&lang=scss&scoped=true&"
import style1 from "./pdetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c278f79",
  null
  
)

export default component.exports